import * as React from 'react'
// components
import { Link, Table } from 'components/UI'
import { TableRow } from '@mui/material'
// context
import { ObjectsAndPropertiesPageContext } from 'containers/ObjectsAndProperties/Register/layers/API'
import { TableManagementContext } from 'containers/Search/layers/BL'
// themes
import { TableCell } from 'themes/views/tables'

const headers = [
  { id: 'objects.name', sortable: false, left: true, label: 'NAME' },
  { id: 'objects.api', sortable: false, left: true, label: 'API NAME' }
]

const ObjectsAndPropertiesTable: React.FC = () => {
  const { handleSetPage, handleSetPerPage, page, perPage } = React.useContext(TableManagementContext)
  const { data, totalCount, refetch, isRefetching } = React.useContext(ObjectsAndPropertiesPageContext)

  return (
    <Table
      data={data}
      page={page}
      title='Objects'
      headers={headers}
      perPage={perPage}
      refetch={refetch}
      totalCount={totalCount}
      isLoading={isRefetching}
      onPageChange={handleSetPage}
      onPerPageChange={handleSetPerPage}>
      {({ data }) =>
        data.map(({ apiName, id, name }) => (
          <TableRow key={id} hover>
            <TableCell>
              <Link href={`/settings/objects/${id}`}>{name}</Link>
            </TableCell>
            <TableCell>{apiName}</TableCell>
          </TableRow>
        ))
      }
    </Table>
  )
}

export default ObjectsAndPropertiesTable
